import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import stilePulsanti from '../interfaccia/stilePulsanti';
import apiUrl from '../Apiurl';
import axios from 'axios';

function ConsultazioneRicerca({prodotto, setProdotto}) {

    const [input, setInput] = useState({
        barcode: "",
        codiceVS: ""
    });
    const [message, setMessage] = useState(null);
    const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");

    useEffect(() => {
        const getUserMetadata = async () => {
            try {
                const accessToken = await getAccessTokenSilently();
                setToken(accessToken);
            } catch (e) {
                console.log(e.message);
            }
        };
        getUserMetadata();
      }, [getAccessTokenSilently, user?.sub]);

    const {
        tastoCercaAspetto,
    } = stilePulsanti

    const handleInput = async function (evt) {
        const value = evt.target.value;
        try {
            if (evt.target.name === "barcode") {
                setInput({
                    barcode: value,
                    codiceVS: ""
                });
            } else if (evt.target.name === "codiceVS") {
                setInput({
                    barcode: "",
                    codiceVS: value
                });
            }
        } catch (err) {
            console.log("Errore nel cambio dello stato input: " + err)
            throw err;
        }
    }

    const handleKeyDown = async function (event) {
        //console.log(event.key);
        if (event.key === 'Enter') {
            event.preventDefault();
            try {
                cercaEImpostaProdotto();
            } catch (err) {
                console.log("Errore nella gestione del tasto invio: " + err)
                throw err;
            }
        }
    };

    const cercaEImpostaProdotto = async function () {
        let response;
        let prodottoTrovato;
        try {
            if (!token) {
                console.warn("sto aspettando un token")
                return;
            }
            const config = {
                headers: {
                    'Authorization': 'Bearer ' + token,
                }
             } 
             const params = new URLSearchParams(input)
             const url = apiUrl + "/terminali/consultazione?"+params;
             response = await axios.get(url,config);
             if (response.data) {
                prodottoTrovato= response.data
             }
            
        } catch (err) {
            console.log("Errore in cercaEImpostaProdotto: " + err)
            throw err;
        }
        if (!prodottoTrovato || prodottoTrovato.length === 0) {
            setMessage("Nessun prodotto trovato");
        } else {
            setProdotto(prodottoTrovato);
        }
    }
    
    
   return (
            <div className='pa4 flex flex-column items-center h-100 mw7'>
                <div className="material-symbols-outlined f1 mb3 scrittaColScuro">mystery</div>
                <div className='ttu f4 b mb4 w-100 tc scrittaColScuro'>Consultazione prodotto</div>
                
                <div className='mt4 b nonSelezionabile tc f5'>EAN</div>
                <div className='gruppoInputRicercaOrizzontale mt2 mb4 w-100'>
                <input
                        autoFocus
                        type="text"
                        id="barcode"
                        name="barcode"
                        value={input.barcode}
                        autoComplete="off"
                        onChange={handleInput}
                        className={"input-reset inputOrizzontale"}
                        onKeyDown={handleKeyDown}
                    />
                    <button onClick={(e) => { cercaEImpostaProdotto() }} className='tastoInputOrizzontale'>{tastoCercaAspetto}</button>
                </div>
                <div className='b nonSelezionabile tc f5'>CODICE VS</div>
                <div className='gruppoInputRicercaOrizzontale mt2 mb4 w-100'>
                <input
                        type="number"
                        id="codiceVS"
                        name="codiceVS"
                        value={input.codiceVS}
                        autoComplete="off"
                        onChange={handleInput}
                        className={"input-reset inputOrizzontale"}
                        onKeyDown={handleKeyDown}
                    />
                    <button onClick={(e) => { cercaEImpostaProdotto() }} className='tastoInputOrizzontale'>{tastoCercaAspetto}</button>
                    
                </div>
                {message && <div className='mt3 br3 pa3 bg-red f5 w-100 ttu tc b white'>{message}</div>}
            </div>
        );

}

export default ConsultazioneRicerca;